import ComplaintsList from './complaints-list';

export default ComplaintsList;
